export const userConstants = {
  LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
  LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
  LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',
  GETALL_FAILURE: 'USERS_GETALL_FAILURE',
  REACTIVATE_USER_SUCCESS: 'REACTIVATE_USER_SUCCESS',
};
